<template>
  <div>
    <MembersUpdateAllDialog
      v-show="visibleDialog('MembersConfirmingDialog') && allMembersSelected"
      @nextStep="nextStep"
      @skipToUpload="skipToUpload"
      @close="close"
    />
    <MembersUpdateConfirmSelectDialog
      v-show="visibleDialog('MembersConfirmingDialog') && !allMembersSelected"
      @nextStep="nextStep"
      @skipToUpload="skipToUpload"
      @close="close"
    />
    <MembersUpdateProfileFieldsDialog
      v-show="visibleDialog('ProfileFieldsSelectionDialog')"
      @nextStep="nextStep"
      @skipToUpload="skipToUpload"
      @close="close"
    />
    <MembersUpdateUploadFileDialog
      v-show="visibleDialog('UploadFileDialog')"
      @download-template="backToDownload"
      @close="close"
      @file-uploaded="onFileUploaded"
    />
    <MembersUpdateProcessingDialog
      v-show="visibleDialog('ProcessingDialog')"
      :import-id="importId"
      @close="close"
      @skipToUpload="skipToUpload"
    />
  </div>
</template>

<script>
import MembersUpdateAllDialog from '~/components/members/MembersUpdateAllDialog.vue';
import MembersUpdateConfirmSelectDialog from '~/components/members/MembersUpdateConfirmSelectDialog.vue';
import MembersUpdateProfileFieldsDialog from '~/components/members/MembersUpdateProfileFieldsDialog.vue';
import MembersUpdateUploadFileDialog from '~/components/members/MembersUpdateUploadFileDialog.vue';
import MembersUpdateProcessingDialog from '~/components/members/MembersUpdateProcessingDialog.vue';
import { mapGetters } from 'vuex';

const STEPS = ['MembersConfirmingDialog', 'ProfileFieldsSelectionDialog', 'UploadFileDialog', 'ProcessingDialog'];

export default {
  name: 'MembersUpdateDialog',
  components: {
    MembersUpdateAllDialog,
    MembersUpdateConfirmSelectDialog,
    MembersUpdateProfileFieldsDialog,
    MembersUpdateUploadFileDialog,
    MembersUpdateProcessingDialog,
  },
  data() {
    return {
      step: 0,
      importId: null,
    };
  },
  computed: {
    ...mapGetters(['apiErrors', 'batchActionIdsCount', 'totalRecordsCount']),
    dialogStep() {
      return STEPS[this.step];
    },
    allMembersSelected() {
      return this.batchActionIdsCount === 0 || this.batchActionIdsCount === this.totalRecordsCount;
    },
  },
  watch: {
    apiErrors: {
      deep: true,
      handler(newApiErrors, oldApiErrors) {
        if (oldApiErrors.length < newApiErrors.length) {
          this.$appMessage(newApiErrors[newApiErrors.length - 1]);
        }
      },
    },
  },
  methods: {
    visibleDialog(dialog) {
      return this.dialogStep === dialog;
    },
    close() {
      this.$emit('close');
    },
    nextStep() {
      this.step += 1;
    },
    skipToUpload() {
      this.step = STEPS.indexOf('UploadFileDialog');
    },
    backToDownload() {
      this.step = 0;
    },
    onFileUploaded(response) {
      if (response?.import_id) {
        this.importId = response.import_id;
        this.nextStep();
      }
    },
  },
};
</script>
